import React, { Fragment, ReactNode } from 'react'
import { Reveal, Flip, JackInTheBox, Bounce, Hinge, Roll } from 'react-awesome-reveal'
import { keyframes } from '@emotion/react'
import * as styles from './SectionHead.module.scss'

interface SectionHeadProps {
  title: string
  text?: ReactNode

}
const SectionHead: React.FC<SectionHeadProps> = ({ title, text }: SectionHeadProps) => {
  const customAnimation = keyframes`
    from {
      clip-path: inset(0 0 100% 0);
      transform: translate(0, 100%);
      visibility: visible;
      opacity: 1;
    }

    to {
      clip-path: inset(0 0 0 0);
      transform: translate(0, 0);
      opacity: 1;
    }
  `
  const splitTitle = title.split(' ')

  return (
    <>
      <h2 className={styles.title}>
        <Reveal
          keyframes={customAnimation}
          cascade
          triggerOnce
          damping={0.4}
          duration={(splitTitle.length >= 8 ? 3.5 : 5.6) / 24 * 1000}
          style={{
            display: 'inline-block',
            clipPath: 'inset(0 0 100% 0)'
          }}
        >
          {splitTitle.map((word, idx) => (
            <span key={idx}>
              {word}{idx < splitTitle.length - 1 ? (<>&nbsp;</>) : ''}
            </span>
          ))}
        </Reveal>
      </h2>
      {text && (
        <div className={styles.text}>
          {text}
        </div>
      )}
    </>
  )
}

export default SectionHead
